import { render, staticRenderFns } from "./AllergensAi.vue?vue&type=template&id=75d8af33&scoped=true"
import script from "./AllergensAi.vue?vue&type=script&lang=ts"
export * from "./AllergensAi.vue?vue&type=script&lang=ts"
import style0 from "@/components/wellness/wellness-base.css?vue&type=style&index=0&id=75d8af33&prod&scoped=true&lang=css&external"
import style1 from "./AllergensAi.vue?vue&type=style&index=1&id=75d8af33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d8af33",
  null
  
)

export default component.exports